import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate {

  constructor(private router: Router, private auth: AuthService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (!this.auth.currentToken || !this.auth.currentToken.key) {
      this.router.navigate(['/auth/login']);
      return false;
    } else if (this.auth.currentUser && this.auth.currentUser.isOrgAdmin) {
      this.router.navigate(['/courses']);
      return false;
    } else {
      this.router.navigate(['/profile']);
      return false;
    }
  }
}
